var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlag = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 0.5C2.5 0.223858 2.27614 0 2 0C1.72386 0 1.5 0.223858 1.5 0.5V23.5C1.5 23.7761 1.72386 24 2 24C2.27614 24 2.5 23.7761 2.5 23.5L2.5 0.5ZM22.5 3H3.00001V16.5H22.5L18 9.75L22.5 3Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/flag.046330017a074dfa927fb67711bddda3.svg";